import Marquee from "react-fast-marquee";
import { useLang } from "@/context/LanguageContext";

export const MarqueeStrip = () => {
  const { t } = useLang();
  const text = t.marquee;
  return (
    <div className="py-10 border-y border-white/10 bg-[#080808]" data-testid="marquee">
      <Marquee speed={40} gradient={false} autoFill>
        <span className="font-display uppercase text-6xl md:text-8xl mx-6 stroke-text">{text}</span>
      </Marquee>
    </div>
  );
};
